/**
 * Lets surfaces outside the dock open the Oscar drawer — the beta banner today.
 *
 * The drawer's open state is local to `OscarDock`, which is mounted once in the
 * top bar and portals itself to <body>. A window event keeps that state where
 * it is instead of hoisting it into Redux for a single caller.
 *
 * Nothing listens while the dock is unmounted (fullscreen Oscar, or the flag
 * off), so a request then is a no-op — callers should only render where the
 * dock is mounted.
 */
const OPEN_PANEL_EVENT = 'oscar:open-panel';

export const requestOscarPanelOpen = (): void => {
	window.dispatchEvent(new Event(OPEN_PANEL_EVENT));
};

/** Returns the unsubscribe, so it can be handed straight back from an effect. */
export const onOscarPanelOpenRequest = (listener: () => void): (() => void) => {
	window.addEventListener(OPEN_PANEL_EVENT, listener);
	return () => window.removeEventListener(OPEN_PANEL_EVENT, listener);
};
